import { ComponentProps, useEffect } from 'react'
import { classNames } from '@/util/tailwindHelpers'
import { ModalCloseButton } from '../Modals/ModalV2/ModalCloseButton'

interface BrowserDetailSheetProps extends ComponentProps<'div'> {
  onClickOutside: () => void
}

const DetailSheet = ({
  children,
  onClickOutside,
  className,
  style,
  ...rest
}: BrowserDetailSheetProps) => {
  useEffect(() => {
    document.body.classList.add('blockBodyScrolling')
    return () => {
      document.body.classList.remove('blockBodyScrolling')
    }
  }, [])

  return (
    <div
      className={'fixed left-0 w-screen h-full z-[200] flex justify-end'}
      style={{ top: 'var(--headerHeight)', ...style }}
      {...rest}
    >
      <button
        className="flex-1 bg-gradient-to-l from-black/97 to-black/75"
        onClick={onClickOutside}
      />
      <div
        className={classNames(
          'flex flex-col bg-black w-[400px] border-l-1 border-defaultBorder',
          className
        )}
      >
        <ModalCloseButton
          onClick={onClickOutside}
          className="absolute right-2 top-2 z-10"
        />
        {children}
      </div>
    </div>
  )
}

export default DetailSheet
